import { Badge } from '@/components/ui';
import type { VideoTriage } from '@/features/video-consults/types';
import parity from '@/pages/ops/parity.module.css';

const RESULT = {
  ok: { text: 'Suitable for video', tone: 'success' },
  emergency: { text: 'Emergency: call 999', tone: 'danger' },
  in_person: { text: 'Needs an in-person visit', tone: 'warning' },
} as const;

const DURATION = {
  today: 'since today',
  days_1_3: '1–3 days',
  days_4_7: '4–7 days',
  over_week: 'over a week',
} as const;

/** The patient's three quick checks (RL-1002); symptoms are their own words. */
export function TriageSummary({ triage }: { triage: VideoTriage | null }) {
  if (!triage) return <span className={parity.sub}>No triage answers</span>;
  const r = RESULT[triage.result];
  return (
    <>
      <Badge tone={r.tone}>{r.text}</Badge>
      {triage.symptoms && (
        <span className={parity.sub}>
          “{triage.symptoms}”
          {triage.duration && ` · ${DURATION[triage.duration]}`}
        </span>
      )}
    </>
  );
}
